import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services';
import { MaintenanceService } from '@app/services/maintenance.service';
import { ToastrService } from 'ngx-toastr';

@UntilDestroy()
@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  login = '';
  password = '';
  hasError = false;
  blockedError = false;
  expire: boolean;
  showPassword = false;
  loading = false;
  pscActive;
  maintenance$ = this.maintenanceService.maintenance$;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private maintenanceService: MaintenanceService,
  ) {
    this.pscActive = environment.pscActive;
  }

  ngOnInit(): void {
    this.expire = !!this.route.snapshot.queryParams.expire;

    this.authService.clearCookieUser();
  }

  auth() {
    this.loading = true;

    this.authService
      .authentication(this.login, this.password, this.authService.getDeviceToken())
      .pipe(
        catchError((err) => {
          this.hasError = true;
          this.loading = false;
          if (err.error?.error === 'Blocked') {
            this.blockedError = true;
          } else if (err.status === 429) {
            this.toastr.error(this.translate.instant('login.error_ratelimit'));
          }
          return of(err);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }

  connectPSC() {
    document.location.href =
      `${environment.pscAuth}?redirect_uri=${environment.pscRedirectUri}` +
      `&client_id=${environment.pscClientId}&response_type=code&scope=openid%20scope_all&acr_values=eidas1`;
  }
}
